(function(){
  var S = window.vagabondStores || [];
  if (!S.length) return;

  // Detect which container exists
  var mapId = document.getElementById('vgb-fullmap') ? 'vgb-fullmap' : 'vgb-map-container';
  var isFullPage = mapId === 'vgb-fullmap';
  var mapEl = document.getElementById(mapId);
  if (!mapEl) return;

  var map = L.map(mapId, {
    zoomControl: true,
    scrollWheelZoom: isFullPage
  }).setView([46.5, -72.0], isFullPage ? 7 : 6);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap',
    maxZoom: 18
  }).addTo(map);

  var customIcon = L.divIcon({
    className: '',
    html: '<svg width="24" height="36" viewBox="0 0 24 36"><path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24C24 5.4 18.6 0 12 0z" fill="#F83535"/><circle cx="12" cy="12" r="5" fill="white"/></svg>',
    iconSize: [24, 36],
    iconAnchor: [12, 36],
    popupAnchor: [0, -36]
  });

  var clusterGroup = L.markerClusterGroup({
    maxClusterRadius: isFullPage ? 50 : 40,
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false
  });

  var allMarkers = [];
  S.forEach(function(s) {
    var m = L.marker([parseFloat(s[0]), parseFloat(s[1])], { icon: customIcon });
    m.bindPopup('<div style="font-size:13px;min-width:160px"><strong>' + s[2] + '</strong><br>' + s[3] + '<br>' + s[4] + ', ' + s[5] + '</div>');
    m._storeData = s;
    clusterGroup.addLayer(m);
    allMarkers.push(m);
  });
  map.addLayer(clusterGroup);

  // Update count if element exists
  var countEl = document.getElementById('vgb-count');
  var pluralEl = document.getElementById('vgb-plural');
  if (countEl) countEl.textContent = allMarkers.length;
  if (pluralEl) pluralEl.textContent = allMarkers.length !== 1 ? 's' : '';

  // Show all results in sidebar (full page only)
  if (isFullPage) {
    showResults(allMarkers, null);
  }

  function deg2rad(d) { return d * (Math.PI / 180); }
  function haversine(lat1, lon1, lat2, lon2) {
    var R = 6371, dLat = deg2rad(lat2 - lat1), dLon = deg2rad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function showResults(list, center) {
    var el = document.getElementById('vgb-results-list') || document.getElementById('vgb-results');
    if (!el) return;
    var html = '';
    list.forEach(function(item, i) {
      var m = item.m || item;
      var s = m._storeData;
      var distStr = item.d ? '<span class="vgb-dist">' + item.d.toFixed(1) + ' km</span><br>' : '';
      html += '<div class="vgb-result-item" style="padding:8px 16px;border-bottom:1px solid rgba(0,0,0,.06);cursor:pointer;font-size:13px" data-idx="' + i + '"><strong>' + s[2] + '</strong>' + distStr + '<span class="vgb-addr" style="color:#666;font-size:12px">' + s[3] + ', ' + s[4] + ' ' + s[5] + '</span></div>';
    });
    if (!list.length) html = '<div style="padding:16px;color:#888;text-align:center">Aucun magasin dans ce rayon.</div>';
    el.innerHTML = html;
    el.querySelectorAll('[data-idx]').forEach(function(div) {
      div.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-idx'));
        var m = (list[idx].m || list[idx]);
        map.setView(m.getLatLng(), 15);
        clusterGroup.zoomToShowLayer(m, function() { m.openPopup(); });
      });
    });
  }

  function doSearch(center, radius) {
    var nearby = [];
    allMarkers.forEach(function(m) {
      var ll = m.getLatLng();
      var d = haversine(center.lat, center.lng, ll.lat, ll.lng);
      if (d <= radius) nearby.push({ m: m, d: d, s: m._storeData });
    });
    nearby.sort(function(a, b) { return a.d - b.d; });
    if (countEl) countEl.textContent = nearby.length;
    if (pluralEl) pluralEl.textContent = nearby.length !== 1 ? 's' : '';
    showResults(nearby, center);
    map.setView([center.lat, center.lng], 11);
  }

  function searchByText(q) {
    q = q.trim().toUpperCase().replace(/\s/g, '');
    if (!q) return;
    var radius = 20;
    var radiusSlider = document.getElementById('vgb-radius-slider');
    if (radiusSlider) radius = parseInt(radiusSlider.value);

    var fsa = q.substring(0, 3);
    var matchExact = [], matchFSA = [];
    allMarkers.forEach(function(m) {
      var spc = (m._storeData[5] || '').toUpperCase().replace(/\s/g, '');
      if (spc === q) matchExact.push(m);
      else if (spc.substring(0, 3) === fsa) matchFSA.push(m);
    });

    var center = null;
    if (matchExact.length > 0) {
      var ll = matchExact[0].getLatLng();
      center = { lat: ll.lat, lng: ll.lng };
    } else if (matchFSA.length > 0) {
      var aLat = 0, aLng = 0;
      matchFSA.forEach(function(m) { var ll = m.getLatLng(); aLat += ll.lat; aLng += ll.lng; });
      center = { lat: aLat / matchFSA.length, lng: aLng / matchFSA.length };
    } else {
      // Search by name or city
      var nameMatch = [];
      allMarkers.forEach(function(m) {
        var name = m._storeData[2].toUpperCase().replace(/\s/g, '');
        var city = m._storeData[4].toUpperCase().replace(/\s/g, '');
        if (name.indexOf(q) >= 0 || city.indexOf(q) >= 0) nameMatch.push(m);
      });
      if (nameMatch.length > 0) {
        var ll = nameMatch[0].getLatLng();
        center = { lat: ll.lat, lng: ll.lng };
      }
    }

    var resultsEl = document.getElementById('vgb-results-list') || document.getElementById('vgb-results');
    if (!center) {
      if (resultsEl) resultsEl.innerHTML = '<div style="padding:16px;color:#c00;text-align:center">Aucun resultat.</div>';
      if (countEl) countEl.textContent = '0';
      return;
    }
    doSearch(center, radius);
  }

  // Bind search buttons
  var searchBtn = document.getElementById('vgb-search-btn') || document.getElementById('vgb-pc-btn');
  var searchInput = document.getElementById('vgb-search-input') || document.getElementById('vgb-pc-search');
  if (searchBtn && searchInput) {
    searchBtn.addEventListener('click', function() { searchByText(searchInput.value); });
    searchInput.addEventListener('keypress', function(e) { if (e.key === 'Enter') searchByText(this.value); });
  }

  // Radius slider
  var radiusSlider = document.getElementById('vgb-radius-slider');
  var radiusVal = document.getElementById('vgb-radius-val');
  if (radiusSlider && radiusVal) {
    radiusSlider.addEventListener('input', function() { radiusVal.textContent = this.value + ' kilometres'; });
  }

  // Geolocation button
  var geoBtn = document.getElementById('vgb-geo-btn');
  if (geoBtn) {
    geoBtn.addEventListener('click', function() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(function(pos) {
        var radius = 20;
        if (radiusSlider) radius = parseInt(radiusSlider.value);
        doSearch({ lat: pos.coords.latitude, lng: pos.coords.longitude }, radius);
      });
    });
  }
})();
